import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
  Select,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { async } from "q";
import axiosInstance from "../../Api/axios.instance";
import useSession from "../../CustomHooks/useSession";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function UserList({ users }) {
  const [user, setUser] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const rowsPerPage = 50;
  const { currentPage } = useSession();
  const [currentPageCRUD] = useState(currentPage[0] ? currentPage[0] : "");
  const [open, setOpen] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackError, setSnackError] = useState(false);
  const [userData, setUserData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [tableData,setTableData] = useState([])
  const [changePassword, setChangePassword] = useState({
    password: "",
    confirmPassword: "",
  });
  // const navigate = useNavigate();
  const [status, setStatus] = useState(false);
  const handleStatusChange = async (id, newStatus) => {
    try {
      // Update local state to reflect immediately
      const updatedData = tableData.map((item) =>
        item.id === id ? { ...item, userStatus: newStatus ? 1 : 0 } : item
      );
      setTableData(updatedData);
  
      // Send to backend using axios
      const { data } = await axiosInstance.post('/users/update-status', {
        id,
        userStatus: newStatus ? 1 : 0,
      });
      const SchoolID = JSON.parse(localStorage.getItem("UserAccess"))[0]
                                  .SchoolId;
      const UserId = JSON.parse(localStorage.User).username;
      const ChangedData = {
        Role : id,
        userStatus: newStatus ? 1 : 0,
      }
      const logParams = {
        user_id : UserId,
        school_id : SchoolID,
        module : 'User Management -Create Role Status', 
        data : JSON.stringify( ChangedData ),
        DML_type : 'Create'
      }
      await axiosInstance.post("/activity_trails/create_activity_trail", logParams);
  
      // Optionally, check the response data
      if (data.success) {
        console.log("Status update successful");
      } else {
        console.error("Status update failed:", data.message);
      }
    } catch (error) {
      console.error("Status update failed", error);
    }
  };
  
  
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await axiosInstance.get(`/users?page=${page}&limit=${rowsPerPage}`);
        setUser(data.user);
        setTotalPages(data.totalPages);
      } catch (err) {
        console.error("Failed to load users:", err);
      }
    };
    fetchUser();
  }, [page]);
  

  const handleChange = (e) => {
    setChangePassword((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };
  const _onSubmit = async (e) => {
    e.preventDefault();
    console.log("changePassword", changePassword);
    try {
      if (changePassword.password !== changePassword.confirmPassword) {
        setSnackError(true);
        setSnackOpen(true);
        setSnackMessage("Password and Confirm Password are not matched!");
      } else {
        const { data, status } = await axiosInstance.put(
          `/users/change-password/${userData.id}`,
          { password: changePassword.password }
        );
        const SchoolID = JSON.parse(localStorage.getItem("UserAccess"))[0]
                                    .SchoolId;
        const UserId = JSON.parse(localStorage.User).username;
        const ChangedData = {
          Role : userData.id,
          password : changePassword.password,
        }
        const logParams = {
          user_id : UserId,
          school_id : SchoolID,
          module : 'User Management -Change Password', 
          data : JSON.stringify( ChangedData ),
          DML_type : 'Edit'
        }
        await axiosInstance.post("/activity_trails/create_activity_trail", logParams);
        console.log("response", data.data);
        if (status === 200) {
          setSnackMessage(data.message);
          setSnackError(false);
          setSnackOpen(true);
          setOpen(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const _handleOnClick = (details) => (e) => {
    // navigate(`user-management/${details.id}`, {
    //   state: {
    //     userData: details,
    //   },
    // });
    console.log(details);
    setUserData(details);
    setOpen(true);
  };
  const handleScoreClose = () => {
    setOpen(false);
  };
  const snack_handleClose = () => {
    console.log("Snack bar Closed");
    setSnackOpen(false);
  };
  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">User Name</TableCell>
              <TableCell align="left">Role</TableCell>
              <TableCell align="center">Access Level</TableCell>
              {/* <TableCell align="center">Designation</TableCell>
            <TableCell align="center">Cell # | Whatsapp #</TableCell>*/}
              <TableCell align="center">Status</TableCell> 
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentPageCRUD.read &&
              users
              .slice((page - 1)* rowsPerPage, page*rowsPerPage)
              .map((row, index) => (
                <TableRow
                  key={String(index)}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.username}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.Role.RoleName}
                  </TableCell>
                  <TableCell align="center">{row.AccessLevel}</TableCell>
                  {/* <TableCell align="center"></TableCell>
              <TableCell align="center"></TableCell>
              onChange={e =>handleStatusChange(e.target.value, row.id)}*/}
                  <TableCell align="center">
                    <FormControl fullWidth sx={{ minWidth: 120 }} size="small">
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={row.userStatus}
                        onChange={(e) => handleStatusChange(row.id, e.target.value)}
                        label="Status"       
                      >
                        <MenuItem key={1} value={true}>
                            Active
                          </MenuItem>
                          <MenuItem key={0} value={false}>
                            In Active
                          </MenuItem>
                      </Select>
                      {/* <Select
                        value={row.userStatus === 1} // true for active, false for inactive
                        onChange={(e) => handleStatusChange(row.id, e.target.value)}
                        label="Status"
                      >
                        <MenuItem value={true}>Active</MenuItem>
                        <MenuItem value={false}>Inactive</MenuItem>
                      </Select> */}
                    </FormControl>
                  </TableCell>

                  <TableCell align="right">
                    <Button variant="contained" onClick={_handleOnClick(row)}>
                      Change Password
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display="flex" justifyContent="center" mt={2}>
        <Button
          disabled={page === 1}
          onClick={() => setPage(prev => prev - 1)}
        >
          Previous
        </Button>
        <Typography variant="body1" mx={2}>Page {page}</Typography>
        <Button
          disabled={page * rowsPerPage >= users.length}
          onClick={() => setPage(prev => prev + 1)}
        >
        Next
        </Button>
      </Box>

      <Dialog fullWidth maxWidth="md" open={open} onClose={handleScoreClose}>
        <DialogTitle>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" component="h2">
              Change Password
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box onSubmit={_onSubmit} component="form">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  label="New Password"
                  type="password"
                  variant="outlined"
                  size="small"
                  sx={{ display: "flex", flex: 1 }}
                  name="password"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  label="Confirm Password"
                  type="password"
                  variant="outlined"
                  size="small"
                  sx={{ display: "flex", flex: 1 }}
                  name="confirmPassword"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <LoadingButton
                  // loading={loading}
                  // disabled={loading}
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  // onClick={formik.handleSubmit}
                >
                  Change Password
                </LoadingButton>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleScoreClose}>Close</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={snack_handleClose}
      >
        <Alert
          onClose={snack_handleClose}
          severity={`${snackError ? "error" : "success"}`}
          sx={{ width: "100%" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
